<mat-form-field [appearance]="appearance" class="w-100">
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select
    #selectElem
    [placeholder]="placeholder"
    [formControl]="formControl"
    [multiple]="multiple"
    [(value)]="selectedValue"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onOpenedChange($event)"
	panelWidth=""
  >
    <div class="box-search">
      <mat-checkbox
        *ngIf="multiple && selectAll"
        color="primary"
        class="box-select-all"
        [(ngModel)]="selectAllChecked"
        (change)="toggleSelectAll($event)"
      ></mat-checkbox>
      <input
        [(ngModel)]="searchInput"
        name="searchInput"
        type="text"
        class="box-search-input"
        [ngClass]="{ 'box-search-input-no-select-all pl-1': !selectAll }"
        (input)="filterItem(searchInput)"
        [placeholder]="selectPlaceholder"
        (keydown)="$event.stopPropagation()"
        #textInput
      />
      <div class="box-clear-icon" (click)="clearSearch()">
        <button mat-icon-button class="clear-button">
          <mat-icon class="mat-24" aria-label="Clear icon">clear</mat-icon>
        </button>
      </div>
    </div>
    <mat-select-trigger>
      {{ onDisplayString() }}
    </mat-select-trigger>
    <mat-option
      *ngIf="!options || options.length <= 0 || filteredOptions?.length <= 0"
      [disabled]="true"
      class="no-checkbox"
      >-- No Items Found --</mat-option
    >
    <mat-option
      *ngFor="let option of options; trackBy: trackByFn"
      [disabled]="option.disabled"
      [value]="option[value]"
      [style.display]="hideOption(option) ? 'none' : 'flex'"
      >{{ option[display] }}
    </mat-option>
  </mat-select>
  <mat-hint style="color: red" *ngIf="showErrorMsg">{{ errorMsg }}</mat-hint>
</mat-form-field>
